export default {
      id: "icon-camasir-ve-utu-odasi-usage",
      viewBox: "0 0 507.4 507.4",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-camasir-ve-utu-odasi",
      toString: function () {
        return this.url;
      }
    }